import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoryBySlug } from "../../../../redux/actions/category";
import { TemporaryStorage } from "../../../../Commons/Utilities/storage";
import { resetState } from "../../redux/actions";

export function useConfirmationStepHook(categorySlug) {
  const { t } = useTranslation("changeService");
  const { isCreating, creationError, creationSuccess } = useSelector(({ changeServices }) => changeServices);
  const dispatch = useDispatch();

  //onMount clear away any LoginRedirect
  useEffect(() => {
    TemporaryStorage.delAfterLoginRedirectURL();
  }, []);

  //onUnMount clear away errorMessaged
  useEffect(() => {
    return () => {
      if (creationError) dispatch(resetState());
    };
  }, [dispatch, creationError]);

  useEffect(() => {
    if (categorySlug) {
      dispatch(fetchCategoryBySlug(categorySlug));
    }
  }, [categorySlug, dispatch]);

  return { t, isCreating, creationError, creationSuccess };
}
